import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7bc4e96c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createElementBlock("div", {
    id: "nav",
    class: _normalizeClass({ collapse: _ctx.$store.state.collapse, 'nav-container': true })
  }, [
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.$store.state.collapse)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "nav-logo",
            src: _ctx.$store.state.project.logo
          }, null, 8, _hoisted_2))
        : (_openBlock(), _createElementBlock("img", {
            key: 1,
            class: "nav-logo mini",
            src: _ctx.$store.state.project.logo_square
          }, null, 8, _hoisted_3)),
      _createVNode(_component_el_menu, {
        "active-text-color": _ctx.activeTextColor,
        "text-color": _ctx.textColor,
        "background-color": _ctx.backgroundColor,
        "default-active": "0",
        mode: "vertical"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menu, (i, k) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: k }, [
              (!i.children)
                ? (_openBlock(), _createBlock(_component_el_menu_item, {
                    key: 0,
                    onClick: ($event: any) => (_ctx.goRouter(i.path)),
                    index: '' + k
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("i", {
                        class: _normalizeClass('nav-icon ' + _ctx.getMenuIcon(i.meta.icon))
                      }, null, 2),
                      _createElementVNode("span", null, _toDisplayString(_ctx.getMenuTitle(i.meta.title)), 1),
                      _createElementVNode("i", {
                        class: _normalizeClass('nav-icon2 ' + i.meta.icon2)
                      }, null, 2)
                    ]),
                    _: 2
                  }, 1032, ["onClick", "index"]))
                : (_openBlock(), _createBlock(_component_el_sub_menu, {
                    key: 1,
                    index: '' + k
                  }, {
                    title: _withCtx(() => [
                      _createElementVNode("i", {
                        class: _normalizeClass('nav-icon ' + _ctx.getMenuIcon(i.meta.icon))
                      }, null, 2),
                      _createElementVNode("span", null, _toDisplayString(_ctx.getMenuTitle(i.meta.title)), 1)
                    ]),
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(i.children, (item, index) => {
                        return (_openBlock(), _createBlock(_component_el_menu_item, {
                          key: index,
                          index: k + '' + index,
                          onClick: ($event: any) => (_ctx.goRouter(item.path))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.getMenuTitle(item.meta.title)), 1)
                          ]),
                          _: 2
                        }, 1032, ["index", "onClick"]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["index"]))
            ], 64))
          }), 128))
        ]),
        _: 1
      }, 8, ["active-text-color", "text-color", "background-color"]),
      (_ctx.$store.state.collapse)
        ? (_openBlock(), _createElementBlock("i", {
            key: 2,
            class: "el-icon el-icon-s-unfold point menu-icon",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$store.commit('setCollapse', false)))
          }))
        : (_openBlock(), _createElementBlock("i", {
            key: 3,
            class: "el-icon el-icon-s-fold point menu-icon",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$store.commit('setCollapse', true)))
          }))
    ])
  ], 2))
}